<template>
    <div class="download-main">
        <div class="download">
            <div class="head">
                <p class="title"><span>{{ getTranslatedText('O! Millionaire new') }}</span> {{ getTranslatedText('is now on your phone!') }}</p>
                <p class="sub-title">{{ getTranslatedText('Play anytime, anywhere! Check results live, buy your Green Certificate securely, and never miss the excitement.') }}</p>
                <p class="sub-title-mb">{{ getTranslatedText('Experience the thrill of live draws, real-time results, and secure ticket purchases on the go.') }}</p>
                <p class="text-download">{{ getTranslatedText('Download now on the App Store or Google Play!') }}</p>
                <div class="btn-group">
                    <a href="https://play.google.com/store/apps/details?id=app.omilionaire&hl=en" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/google-btn.svg" alt="" /></a>
                    <a href="https://apps.apple.com/us/app/omillionaire/id6470261305" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/app-button.svg" alt="" /></a>
                </div>
                <div class="btn-group-mb">
                    <a href="https://play.google.com/store/apps/details?id=app.omilionaire&hl=en" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/google-btn-mb.svg" alt="" /></a>
                    <a href="https://apps.apple.com/us/app/omillionaire/id6470261305" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/app-button-mb.svg" alt="" /></a>
                </div>
            </div>
        </div>
            <img class="img-phone" loading="lazy" src="@/assets/images/static-pages/download/phone.webp" alt="" />
            <img class="img-phone-mb" loading="lazy" src="@/assets/images/static-pages/download/phone-mb.webp" alt="" />
            <img class="img-ball" loading="lazy" src="@/assets/images/static-pages/download/blue-ball.webp" alt="" />
        <div class="content">
                <p class="title">{{ getTranslatedText('O! Millionaire — the world’s first green initiative of its kind.') }}</p>
                <p class="sub-title">{{ getTranslatedText('We’re proud to lead the way, combining sustainability with the power to transform lives. Our mission? A greener planet and a brighter future for all.') }}</p>
                <div class="sub-content">
                <img class="img-green-ball" loading="lazy" src="@/assets/images/static-pages/download/green-ball.webp" alt="" />
                <div class="content-left">
                    <p class="title-left">{{ getTranslatedText('A Greener Future. A Life-Changing Opportunity. Are You In?') }}</p>
                    <p class="sub-title-left">{{ getTranslatedText('Download the O! Millionaire app now to join every weekly experience, track results in real time, and never miss your shot at something extraordinary.') }}</p>
                    <div class="btn-group">
                        <a href="https://play.google.com/store/apps/details?id=app.omilionaire&hl=en" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/google-btn.svg" alt="" /></a>
                        <a href="https://apps.apple.com/us/app/omillionaire/id6470261305" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/app-button.svg" alt="" /></a>
                    </div>
                    <div class="btn-group-mb">
                        <a href="https://play.google.com/store/apps/details?id=app.omilionaire&hl=en" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/google-btn-mb.svg" alt="" /></a>
                        <a href="https://apps.apple.com/us/app/omillionaire/id6470261305" target="_blank"><img loading="lazy" src="@/assets/images/static-pages/download/app-button-mb.svg" alt="" /></a>
                    </div>
                </div>
                <img class="img-device" loading="lazy" src="@/assets/images/static-pages/download/device.webp" alt="" />
                <img class="img-device-mb" loading="lazy" src="@/assets/images/static-pages/download/device-mb.webp" alt="" />
                </div>
        </div>
    </div>
</template>
<script>
import languageMixin from '@/mixins/language/language-mixin';

export default {
    mixins: [languageMixin],
    components: {
    },
    created() {
    },


    
    methods: {
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/download.scss" />
